import React, { FunctionComponent } from "react";
import { Link } from "react-router-dom";
import routes from "../../../app/routes";
import { AppPage } from "../../../components";
import { useTranslate } from "../../../helpers";

const MedigapPlanDetailsErrorPage: FunctionComponent = () => {
  const t = useTranslate();
  return (
    <div style={{ marginBottom: "144px" }} className="ds-u-margin-top--4">
      <AppPage
        heading={t("medigap.plan_details.error_retrieving.heading")}
        data-testid="medigap-plan-details-error-page"
      >
        <span>{t("medigap.plan_details.error_retrieving.message")}</span>{" "}
        <Link to={routes.medigap.plans}>
          {t("medigap.plan_details.error_retrieving.link")}
        </Link>
        .
      </AppPage>
    </div>
  );
};

export { MedigapPlanDetailsErrorPage };
